/**
 * URL hash key to bridge `auth_token` from LINE WebView into the system browser.
 * Fragment is not sent on the initial HTTP request; the summary-external page POSTs it to `/api/auth/set-token` then strips the hash.
 */
export const ARTIFACTS_SUMMARY_EXTERNAL_AUTH_HASH_KEY = "ailo_mt";
